import { connectRefinementList } from "react-instantsearch-dom";
import React from "react";
import BarCheckbox from "../BarCheckbox";
import * as styles from "./RefinementListFilter.module.scss";

const ListRefinement = ({ items, refine }) => {
  return (
    <div className={styles.list}>
      {items.map((item) => {
        const id = Math.random().toString(36);
        return (
          <BarCheckbox
            key={id}
            label={item.label}
            count={item.count}
            disabled={item.count <= 0}
            checked={item.isRefined}
            onChange={(_) => refine(item.value)}
          />
        );
      })}
    </div>
  );
};

const RefinementListFilter = connectRefinementList(ListRefinement);
export default RefinementListFilter;
